import * as types from './types'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.SET_CONNECTED_DEVICES](state, devices) {
    state.connectedDevices = JSON.parse(JSON.stringify(devices))
    console.log('CONNECTED DEVICES -> ', state.connectedDevices)
  },
  [types.SET_CURRENT_DEVICE](state, device) {
    state.currentDevice = null
    if (device !== undefined && device !== null) {
      state.currentDevice = JSON.parse(JSON.stringify(device))
    }
    console.log('CURRENT DEVICE -> ', state.currentDevice)
  },
  [types.SET_DEVICE](state, data) {
    state.device = data
  },
  [types.SET_DEVICES](state, data) {
    state.totalDevices = 0
    state.devices = []
    if (data !== undefined && data !== null) {
      console.log('Devices', data)
      if (data.length > 0) {
        state.totalDevices = data[0].TotalItems
        for (let item of data) {
          item.isChecked = false
        }
        state.devices = data
      }
    }
  },
  [types.CLEAR_DEVICES](state) {
    state.devices = []
  },
  [types.SET_SERVER_PROFILES](state, data) {
    state.serverProfiles = data
  },
  [types.SET_PAIRING_INFO](state, data) {
    state.pairingInfo = data
  },
  [types.SET_WO_PAIRING_INFO](state, data) {
    state.pairingInfoWorkOrder = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/devices/mutations.js